import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateTitle = new ReduxAsyncAction<'UPDATE_TITLE', string, { title: string }>('UPDATE_TITLE');

UpdateTitle.registerRequest(async (title: string) => {
  return { title };
});

export const UPDATE_TITLE = UpdateTitle.actionNamespaceConstants;
export const updateTitle = UpdateTitle.request;

export type UpdateTitleResponseAction = Action<typeof UPDATE_TITLE.response> & {
  data: { title: string };
};
